// import DhivyaS from "../../../../assets/images/staffPhotos/Dhivya_S.jpg";
import Eshobhana from "../../../../assets/images/staffPhotos/Dr.E.Sobhana.jpeg";
import Rsuganya from "../../../../assets/images/staffPhotos/Dr.R.SUGANYA.jpeg";
import BDhivya from "../../../../assets/images/staffPhotos/Ms.B.Dhivya.jpeg";
import MohamedAnsariRaja from "../../../../assets/images/staffPhotos/Dr.A.MohamedAnsari Raja.jpeg";
import ArulRajasekaran from "../../../../assets/images/staffPhotos/Dr.D.ArulRajasekaran.jpeg";
import SashaPriyanka from "../../../../assets/images/staffPhotos/Mrs. S.AshaPriyanka.jpeg";
import KSabarish from "../../../../assets/images/staffPhotos/MrK.Sabarish.jpeg";
import Vel from "../../../../assets/images/staffPhotos/Dr.S.Velprabakaran.jpg";
import Karthikeyan from "../../../../assets/images/staffPhotos/S Karthickeyan.jpg";
import ArunKumar from "../../../../assets/images/staffPhotos/Dr.M.ArunKumar.jpeg";
import suganthi from "../../../../assets/images/staffPhotos/Dr.A.Suganthi.jpg";
import Priyadharsinib from "../../../../assets/images/staffPhotos/Dr.B.Priyadharsini.jpg";
import daniel from "../../../../assets/images/staffPhotos/G.A.Daniel.jpg";
import devanathan from "../../../../assets/images/staffPhotos/R.Devanathan.jpg";
import rashika from "../../../../assets/images/staffPhotos/R.Rashika.png";
import abhinaya from "../../../../assets/images/staffPhotos/Ms.Abhinaya.jpg";
import Sundharavadivu from "../../../../assets/images/staffPhotos/Dr.S.Sundharavadivu.jpg";
import yogapriya from "../../../../assets/images/staffPhotos/R.Yogapriya.jpg";
import mKarthikeyan from "../../../../assets/images/staffPhotos/Mr.M.Karthikeyan.jpg";
import arun from "../../../../assets/images/staffPhotos/Mr. S. Arun, AP (Agrl. Economics).jpeg";
import senthil from "../../../../assets/images/staffPhotos/SenthilMuruganS.jpg";
import munnusamy from "../../../../assets/images/staffPhotos/Munusamy.JPG";
import Sugadev from "../../../../assets/images/staffPhotos/R.Sugadev.png";






// import Suryakala from "../../../../assets/images/staffPhotos/PaulrajSuryakala.jpg";
// import DHIVYADR from "../../../../assets/images/staffPhotos/DHIVYA B.jpeg";
import KARTHIKTR from "../../../../assets/images/staffPhotos/KARTHIK TR.jpeg";
import RagunathR from "../../../../assets/images/staffPhotos/RagunathR.jpg";




import Santhoshkumar from "../../../../assets/images/staffPhotos/Mr. C. Santhoshkumar, AP (Plant Breeding & Genetics).jpeg";
// import Suganthi from "../../../../assets/images/staffPhotos/SuganthiA.jpg";
import Brindhadevi from "../../../../assets/images/staffPhotos/BrindhaDeviS.jpg";
import AnbarasiD from "../../../../assets/images/staffPhotos/AnbarasiD.jpg";
import Arun from "../../../../assets/images/staffPhotos/Mr. S. Arun, AP (Agrl. Economics).jpeg";
import karthkeyanM from "../../../../assets/images/staffPhotos/KARTHIKEYAN M.jpg";
import Senthilmurugan from "../../../../assets/images/staffPhotos/SenthilMuruganS.jpg";
import JeevanathiyalR from "../../../../assets/images/staffPhotos/JeevanathiyalR.jpg";
import JAYAPRAKASH from "../../../../assets/images/staffPhotos/JAYAPRAKASH.jpg";
import Preethi from "../../../../assets/images/staffPhotos/Dr.S.Preethi.jpg";

import Sudha from "../../../../assets/images/staffPhotos/Sudha.jpg";
import VetrimaniV from "../../../../assets/images/staffPhotos/VetrimaniV.jpg";
import VanithaSriJ from "../../../../assets/images/staffPhotos/VanithaSriJ.JPG";
import Mayakrishnan from "../../../../assets/images/staffPhotos/Mayakrishnan.jpg";

import MOHAMEDANSARIRAJA from "../../../../assets/images/staffPhotos/MohamadAnsari.JPG";
import THATCHINAMOORTHY from "../../../../assets/images/staffPhotos/Thatchinamurthy.JPG";
import Pirithiraj from "../../../../assets/images/staffPhotos/Dr. U. PIRITHIRAJ.jpg";
import Revathi from "../../../../assets/images/staffPhotos/Revathi.jpeg";

import Praveena from "../../../../assets/images/staffPhotos/Mrs.P.Praveena.jpeg";
import Abinaya from "../../../../assets/images/staffPhotos/20250913_210412.jpg";
import SAnbarasan from "../../../../assets/images/staffPhotos/Anbarasan.jpeg";

// last id no used 154
export const FacultyData = [
  {
    id: 190,
    image: SAnbarasan,
    fullName: "Dr.S.Anbarasan",
    position: "Assistant Professor",
    department: "Department of Agronomy",
    eMail: "anbumugam10@gmail.com",
    mobile: ["7502133124 ,", " 6382866828"],
    deptType: "Crop Management",
    dateOfBirth: "12.07.1998",
    dateOfJoining: "25.02.2022",
    educationalQualification: "M.Sc.,",
    specialisation: "Agronomy",
    teachingExperience: "1 Year",
    researchExperience: "5 Years",
    netEligibility: "ASRB-NET",
    SeminarsPaperPresented: { national: "13", interNational: "15" },
    Trainingsattended: "6",
    Workshopsattended: "6",
    WorkshopsAttendeds: {
      Internationaljournal: "12",
      Nationaljournal: "7",
      Populararticles: "5",
      Bookschapters: "14",
    },
    BookPublished: { WithISBN: "7", WithoutISBN: " " },
    AwardsReceived: "11",
    ListOutAward: [
      "BEST M.Sc (Agri.) THESIS AWARD – 2022",
      "BEST RESEARCH ARTICLE AWARD – 2023",
      "Young Researcher Award – 2020",
      "Young Achiever Award – 2022",
      "Outstanding Agronomist Performance in Agriculture – 2022",
      "Young Scientist Award – 2022",
      "Dr. APJ. ABDUL KALAM Young Scientist Award – 2022",
      "Dr. NORMAN BORLAUG Best Scientist Award – 2023",
      "Young Agronomist Award – 2024",
      "Young Scientist Award – 2024",
    ],
    WebinarsAttended: "8",
    AdditionalResponsibilities: "College admission committee member",
    AdditionalParticulars: "-",

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 191,
    image: Eshobhana,
    fullName: "Dr.E.Sobhana",
    position: "Assistant Professor",
    department: "Department of Agronomy",
    eMail: "shobaagri1@gmail.com",
    mobile: ["+91 9976417067"],
    deptType: "Crop Management",
    dateOfBirth: "12.07.1998",
    dateOfJoining: "25.02.2022",
    // educationalQualification: "M.Sc.,",
    specialisation: "Conservation agriculture and Weed management ",
    teachingExperience: "2.5 Years",
    researchExperience: "5 Years",
    netEligibility: "ASRB NET 2021",
    SeminarsPaperPresented: { national: "8", interNational: "2" },
    Trainingsattended: "-",
    Workshopsattended: "2",
    WorkshopsAttendeds: {
      Internationaljournal: "3",
      Nationaljournal: "6",
      Populararticles: "9",
      Bookschapters: "9",
    },
    BookPublished: { WithISBN: "4", WithoutISBN: "-" },
    AwardsReceived: "11",
    ListOutAward: [
      "Norman E. Borlaug Young Scientist Award ",
      "Dr. K. Janaki Ammal Best Women Scientist Award",
      "Professional Excellence Award ",
      "Best article award",
    ],
    WebinarsAttended: "4",
    AdditionalResponsibilities: "-",
    AdditionalParticulars: "-",

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 192,
    image: Rsuganya,
    fullName: "Dr.R.SUGANYA",
    position: "Assistant Professor",
    department: "Department of Agronomy",
    eMail: "ganya2911@gmail.com",
    mobile: ["+91 9047028826"],
    deptType: "Crop Management",
    dateOfBirth: "12.07.1998",
    dateOfJoining: "25.02.2022",
    // educationalQualification: "M.Sc.,",
    specialisation:
      "Organic Nutrient Management, Weed Management, Rice Agronomy ",
    teachingExperience: "05 Months",
    researchExperience: "01 Year",
    netEligibility: "ASRB NET 2021, ASRB NET 2025",
    SeminarsPaperPresented: { national: "2", interNational: "--" },
    Trainingsattended: "3",
    Workshopsattended: "12",
    WorkshopsAttendeds: {
      Internationaljournal: "11",
      Nationaljournal: "2",
      Populararticles: "2",
      Bookschapters: "7",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "3",
    ListOutAward: [
      "Young Agronomist Award,  ",
      "Norman E. Borlaug Young Scientist Award ",
      "Best Poster Presentation Award",
    ],
    WebinarsAttended: "33",
    AdditionalResponsibilities:
      "Agronomy lab In-charge, Meteorology Observatory In-charge, SC/ST Scholarship In-charge",

    AdditionalParticulars: [
      "Attended 17 conferences, 10 E-Quizzes, and 9 other activities.",
      "Undergone a Certificate Course in Human Rights Education.",
      "Obtained an Elite + Silver Medal in NPTEL SWAYAM – Nanotechnology in Agriculture.",
    ],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  // {
  //   id: 101,
  //   image: DhivyaS,
  //   fullName: "Ms. S. DHIVYA",
  //   position: "Assistant Professors",
  //   department: "Department of Agronomy",
  //   eMail: "dhivyasubbu98@gmail.com",
  //   mobile: "9150240101",
  //   deptType: "Crop Management",
  //   dateOfBirth: "12.07.1998",
  //   dateOfJoining: "25.02.2022",
  //   educationalQualification: "M.Sc.,",
  //   specialisation: "Agronomy",
  //   // teachingExperience: "",
  //   researchExperience: "2 Years",
  //   // googleScholar: "",
  //   // seminarsAttended: { national: "", interNational: "" },
  //   // conferenceAttended: { national: "", interNational: "" },
  //   WorkshopsAttended: { national: "5", interNational: "" },
  //   trainingsAttended: { national: "1", interNational: "" },
  //   facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
  //   // reviewPapersPresented: { national: "", interNational: "" },
  //   // researchPapersPresented: { national: "", interNational: "" },
  //   // reviewPapersPublished: { national: "", interNational: "" },
  //   researchPapersPublished: { national: "1", interNational: "" },
  //   // populararticlesPublished: { national: "", interNational: "" },
  //   // bookschaptersPublished: { national: "", interNational: "" },
  //   // booksPublished: { national: "", interNational: "" },
  //   // awards: {},
  //   // memberships: {},
  // },
  // {
  //   id: 102,
  //   image: Suryakala,
  //   fullName: "Dr.PAULRAJ SURYAKALA",
  //   position: "Assistant Professor",
  //   department: "Department of Agronomy",
  //   eMail: "Suryapskagri16@gmail.com",
  //   mobile: "9655500170",
  //   deptType: "Crop Management",
  //   dateOfBirth: "10.07.1994",
  //   dateOfJoining: "02.05.2022",
  //   educationalQualification: "M.Sc., Ph.D",
  //   specialisation: "Agronomy",
  //   // teachingExperience: "",
  //   researchExperience: "3",
  //   // googleScholar: "",
  //   seminarsAttended: { national: "3", interNational: "" },
  //   conferenceAttended: { national: "1", interNational: "2" },
  //   WorkshopsAttended: { national: "9", interNational: "" },
  //   trainingsAttended: { national: "4", interNational: "" },
  //   // facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
  //   // reviewPapersPresented: { national: "", interNational: "" },
  //   researchPapersPresented: { national: "1", interNational: "" },
  //   // reviewPapersPublished: { national: "", interNational: "" },
  //   // researchPapersPublished: { national: "6", interNational: "" },
  //   // populararticlesPublished: { national: "", interNational: "" },
  //   bookschaptersPublished: { national: "2", interNational: "" },
  //   // booksPublished: { national: "", interNational: "" },
  //   // awards: {},
  //   // memberships: {},
  // },

  {
    id: 193,
    image: BDhivya,
    fullName: "Ms.B.Dhivya",
    position: "Assistant Professor",
    department: "Department of Agronomy",
    eMail: "dhivyaagr24@gmail.com",
    mobile: ["+91 9488151496"],
    deptType: "Crop Management",
    dateOfBirth: "07.03.1999",
    // dateOfJoining: "25.02.2022",
    educationalQualification: "M.Sc., (Agri)",
    specialisation: "Agronomy ",
    teachingExperience: "2 Years",
    researchExperience: "-",
    netEligibility: "-",
    SeminarsPaperPresented: { national: "1", interNational: "1" },
    Trainingsattended: "1",
    Workshopsattended: "1",
    WorkshopsAttendeds: {
      Internationaljournal: "-",
      Nationaljournal: "1",
      Populararticles: "-",
      Bookschapters: "-",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "3",
    ListOutAward: ["Nill"],
    WebinarsAttended: "1",
    AdditionalResponsibilities: "Nill",

    AdditionalParticulars: ["Wetland staff incharge"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 194,
    image: MohamedAnsariRaja,
    fullName: "Dr.A. MOHAMED ANSARI RAJA",
    position: "Assistant Professor",
    department: "Soil science and Agricultural chemistry",
    eMail: "ansariraja95@gmail.com",
    mobile: ["+91 9698271391"],
    deptType: "Crop Management",
    // dateOfBirth: "07.03.1999",
    // dateOfJoining: "25.02.2022",
    // educationalQualification: "M.Sc., (Agri)",
    specialisation: "Soil survey, Micronutrient analysis, Pedology ",
    teachingExperience: "3 Years",
    researchExperience: "2 Years",
    netEligibility: "",
    SeminarsPaperPresented: { national: "4", interNational: "1" },
    Trainingsattended: "1",
    Workshopsattended: "4",
    WorkshopsAttendeds: {
      Internationaljournal: "1",
      Nationaljournal: "4",
      Populararticles: "2",
      Bookschapters: "1",
    },
    BookPublished: { WithISBN: "4", WithoutISBN: "-" },
    AwardsReceived: "3",
    ListOutAward: [
      "Dr.A.P.J.Abdul Kalam Young Scientist award (2022)",
      "Innovative Research Award (Millets) (2023)",
      "Best Teacher Award - SCITSA, New Delhi, India and TNAU, Coimbatore",
      "Best Author Awards- SCITSA, New Delhi, India",
      "Best Poster and Oral Presentation Award – Multiple National and International Conferences in 2021,2022,2023",
    ],
    WebinarsAttended: "-",
    AdditionalResponsibilities: [
      "Year coordinator (2024 batch)",
      "Discipline committee incharge, Lab incharge",
    ],

    AdditionalParticulars: [
      "Good knowledge in R software",
      "SPSS and statistical analysis",
    ],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 195,
    image: ArulRajasekaran,
    fullName: "Dr.D.ArulRajasekaran",
    position: "Assistant Professor",
    department: "Soil Science & Agricultural Chemistry",
    eMail: "arulrajasekaran1510@gmail.com",
    mobile: ["+91 9659808352"],
    deptType: "Crop Management",
    // dateOfBirth: "07.03.1999",
    // dateOfJoining: "25.02.2022",
    // educationalQualification: "M.Sc., (Agri)",
    specialisation: "Soil Fertility",
    teachingExperience: "1 Year 4 Months",
    researchExperience: "4 Years",
    netEligibility: "",
    SeminarsPaperPresented: { national: "8", interNational: "2" },
    Trainingsattended: "1",
    Workshopsattended: "4",
    WorkshopsAttendeds: {
      Internationaljournal: "4",
      Nationaljournal: "3",
      Populararticles: "3",
      Bookschapters: "2",
    },
    BookPublished: { WithISBN: "1", WithoutISBN: "-" },
    AwardsReceived: "3",
    ListOutAward: [
      "Best Oral Presentation award  (ICOSCF-2025) in International conference – Effect of Nano Zn and Fe composites on the fortification of rice in coastal soil at Annamalai University sponsored by TNSCST",
      "Best Oral Presentation award (AIASA 2020) in international conference -Effect of fortified organic manure on sustaining soil nutrient availability in coastal saline soil at Annamalai University",
      "Best Poster Presentation (APSR-2019) in national seminar – Effect of fortified organic manure on the nutrient content and uptake by black gram in coastal saline soil Sponsored by UGC-SAP",
    ],
    WebinarsAttended: "7",
    AdditionalResponsibilities: ["-"],

    AdditionalParticulars: [
      "Patent: An AI-Driven Precision Soil Health Assessment System for Crop Productivity Enhancement – 2026.",
      "Research experience: Nano Zn and Fe composites, rice biofortification, coastal saline soil, nutrient management",
      "Research skills: Synthesis and characterization of nanoparticles; laboratory and field experiments; statistical analysis.",
      "Project experience: Project Assistant in Effect of Micronutrients with and without Nitrogen on Rice – 2020. Stanes Company",
      "Crop advisory experience: Worked as Crop Advisor at Cropex Company Pvt. Ltd., Chennai.",
      "Trainer: Worked as Trainer under Naan Muthalvan Scheme – 2024.",
      "Areas of interest: Research & Development; Soil Fertility and Nutrient Management.",
    ],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    /* Name: Mrs. S. Asha Priyanka */
  },
  {
    id: 196,
    image: SashaPriyanka,
    fullName: "Mrs. S. AshaPriyanka",
    position: "Assistant Professor",
    department: "Agricultural Microbiology",
    eMail: "s.ashapriyanka7@gmail.com",
    mobile: ["+91 8072840538"],
    deptType: "Crop Management",
    // dateOfBirth: "07.03.1999",
    // dateOfJoining: "25.02.2022",
    educationalQualification: "M.Sc.,(Agri)",
    specialisation: "Microbiology",
    teachingExperience: "4 Years",
    researchExperience: "-",
    netEligibility: "-",
    SeminarsPaperPresented: { national: "1", interNational: "1" },
    Trainingsattended: "1",
    Workshopsattended: "1",
    WorkshopsAttendeds: {
      Internationaljournal: "4",
      Nationaljournal: "1",
      Populararticles: "1",
      Bookschapters: "-",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "-",
    ListOutAward: ["--"],
    WebinarsAttended: "7",
    AdditionalResponsibilities: ["-"],

    AdditionalParticulars: [
      "Microbiology Lab Incharge",
      "Reappearance Exam coordinator",
    ],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 197,
    image: KSabarish,
    fullName: "Mr. K.Sabarish",
    position: "Assistant Professor",
    department: "Environmental Science",
    eMail: "sabarishanburks@gmail.com",
    mobile: ["+91 9047590249"],
    deptType: "Crop Management",
    dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    educationalQualification: "M.Sc., (Agri)",
    specialisation: "Environmental Science",
    teachingExperience: "2 Years",
    researchExperience: "-",
    netEligibility: "UGC",
    SeminarsPaperPresented: { national: "1", interNational: "1" },
    Trainingsattended: "1",
    Workshopsattended: "5",
    WorkshopsAttendeds: {
      Internationaljournal: "1",
      Nationaljournal: "1",
      Populararticles: "-",
      Bookschapters: "-",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "-",
    ListOutAward: ["--"],
    WebinarsAttended: "2",
    AdditionalResponsibilities: ["-"],

    AdditionalParticulars: [
      "College Admission committee",
      "Vermicomposting unit in charge",
    ],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 198,
    image: Vel,
    fullName: "Dr.S.Velprabakaran",
    position: "Assistant Professor",
    department: "Plant Breeding and Genetics",
    eMail: "anbudanvel@gmail.com",
    mobile: ["+91 9659970832"],
    deptType: "Crop Improvement",
    dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    educationalQualification: "M.Sc., (Agri)",
    specialisation: "Plant Breeding and Genetics",
    teachingExperience: "5 Years",
    researchExperience: "3 Years",
    netEligibility: "ASRB",
    SeminarsPaperPresented: { national: "10", interNational: "5" },
    Trainingsattended: "2",
    Workshopsattended: "5",
    WorkshopsAttendeds: {
      Internationaljournal: "5",
      Nationaljournal: "5",
      Populararticles: "3",
      Bookschapters: "3",
    },
    BookPublished: { WithISBN: "4", WithoutISBN: "-" },
    AwardsReceived: "2",
    ListOutAward: ["--"],
    WebinarsAttended: "5",
    AdditionalResponsibilities: ["-"],

    AdditionalParticulars: ["Vice Principal", "College Admission committee"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 199,
    image: Karthikeyan,
    fullName: "Dr.S.Karthikeyan",
    position: "Assistant Professor",
    department: "Plant Breeding and Genetics",
    eMail: "karthickagri08@gmail.com",
    mobile: ["+91 8925094381"],
    deptType: "Crop Improvement",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    // educationalQualification: "M.Sc., (Agri)",
    specialisation: "Gender",
    teachingExperience: "8 Years",
    researchExperience: "5 Years",
    netEligibility: "-",
    SeminarsPaperPresented: { national: "4", interNational: "5" },
    Trainingsattended: "4",
    Workshopsattended: "4",
    WorkshopsAttendeds: {
      Internationaljournal: "4",
      Nationaljournal: "4",
      Populararticles: "3",
      Bookschapters: "3",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "1",
    ListOutAward: ["--"],
    WebinarsAttended: "3",
    AdditionalResponsibilities: ["-"],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 200,
    image: ArunKumar,
    fullName: "Dr.M.ArunKumar",
    position: "Assistant Professor",
    department: "Plant Breeding and Genetics)",
    eMail: "Arunajithmak10@gmail.com",
    mobile: ["+91 9715617468"],
    deptType: "Crop Improvement",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    // educationalQualification: "M.Sc., (Agri)",
    specialisation: "Conventional breeding and molecular breeding",
    teachingExperience: "-",
    researchExperience: "2 Years",
    netEligibility: "-",
    SeminarsPaperPresented: { national: "3", interNational: "-" },
    Trainingsattended: "-",
    Workshopsattended: "-",
    WorkshopsAttendeds: {
      Internationaljournal: "3",
      Nationaljournal: "2",
      Populararticles: "2",
      Bookschapters: "3",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "-",
    ListOutAward: ["--"],
    WebinarsAttended: "1",
    AdditionalResponsibilities: ["Assistant Exam Coordinator"],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 201,
    image: suganthi,
    fullName: "Dr.A.Suganthi",
    position: "Assistant Professor",
    department: "Seed Science and Technology",
    eMail: "suganthiathi09@gmail.com",
    mobile: ["+91 9789228396"],
    deptType: "Crop Improvement",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    // educationalQualification: "M.Sc., (Agri)",
    specialisation: "Seed vigour and seed storage",
    teachingExperience: "7 Years",
    researchExperience: "5 Years",
    netEligibility: "ASRB - 2014",
    SeminarsPaperPresented: { national: "10", interNational: "4" },
    Trainingsattended: "1",
    Workshopsattended: "6",
    WorkshopsAttendeds: {
      Internationaljournal: "6",
      Nationaljournal: "1",
      Populararticles: "1",
      Bookschapters: "2",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "1" },
    AwardsReceived: "6",
    ListOutAward: [
      "Best Ph.D student Award in Seed Science and Technology by Nitta Gelatin India Limited, Kochi, 2019",
      "Young Teaching Faculty Award",
      ". Best Young Scientist Award",
      ". Young Professional Award",
      "Mother Terasa Women Scientist Award",
      "Best Poster Presentation Award",
    ],
    WebinarsAttended: "2",
    AdditionalResponsibilities: [
      "Academic Coordinator",
      "Plant Physiology Lab incharge",
      "Member of disciplinary committee of College",
    ],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 202,
    image: Priyadharsinib,
    fullName: "B.Priyadharsini",
    position: "Assistant Professor",
    department: "Biotechnology",
    eMail: "priyadharshnicid@gmail.com ",
    mobile: ["+91 9443749352"],
    deptType: "Crop Improvement",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    // educationalQualification: "M.Sc., (Agri)",
    specialisation: "Molecular analysis, research, data analysis",
    teachingExperience: "7 Years",
    researchExperience: "5 Years",
    netEligibility: "-",
    SeminarsPaperPresented: { national: "8", interNational: "5" },
    Trainingsattended: "4",
    Workshopsattended: "3",
    WorkshopsAttendeds: {
      Internationaljournal: "2",
      Nationaljournal: "2",
      Populararticles: "2",
      Bookschapters: "1",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "1" },
    AwardsReceived: "-",
    ListOutAward: ["-"],
    WebinarsAttended: "2",
    AdditionalResponsibilities: [
      "Biotechnology Lab In charge",
      "PA to Principal",
    ],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 203,
    image: daniel,
    fullName: "Dr.G.ANDONISSAMY DANIEL",
    position: "Assistant Professor",
    department: "Crop Physiology",
    eMail: "antondaniel1996@gmail.com",
    mobile: ["+91 7598302290"],
    deptType: "Crop Improvement",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    // educationalQualification: "M.Sc., (Agri)",
    specialisation: "Crop Physiology",
    teachingExperience: "-",
    researchExperience: "-",
    netEligibility: "ASRB NET",
    SeminarsPaperPresented: { national: "4", interNational: "1" },
    Trainingsattended: "1",
    Workshopsattended: "3",
    WorkshopsAttendeds: {
      Internationaljournal: "1",
      Nationaljournal: "4",
      Populararticles: "2",
      Bookschapters: "1",
    },
    BookPublished: { WithISBN: "4", WithoutISBN: "4" },
    AwardsReceived: "7",
    ListOutAward: [
      "ICAR-JRF fellowship",
      "ICAR-SRF-fellowship",
      "Best M.Sc. Thesis Award @MTCA & AIASA 2024",
      "Best Poster Award @ NCPP 2024",
      "Best Poster Award @MTCA & AIASA 2025",
      "Young Scientist Award @MTCA & AIASA 2025",
      "PAJANCOA overall best allrounder award @PAJANCOA & RI 2014-2018",
    ],
    WebinarsAttended: "-",
    AdditionalResponsibilities: ["-"],

    AdditionalParticulars: [
      "Good knowledge in R software, SPSS and statistical analysis",
    ],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 204,
    image: Preethi,
    fullName: "Dr.S.Preethi",
    position: "Assistant Professor",
    department: "Agricultural Entomology",
    eMail: "preethikaviprakash@gmail.com",
    mobile: ["+91 7708095632"],
    deptType: "Crop Protection",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    // educationalQualification: "M.Sc., (Agri)",
    specialisation: "Toxicology",
    teachingExperience: "3 Years",
    researchExperience: "5 Years",
    netEligibility: "ASRB NET",
    SeminarsPaperPresented: { national: "-", interNational: "1" },
    Trainingsattended: "-",
    Workshopsattended: "-",
    WorkshopsAttendeds: {
      Internationaljournal: "4",
      Nationaljournal: "2",
      Populararticles: "-",
      Bookschapters: "-",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "7",
    ListOutAward: ["-"],
    WebinarsAttended: "3",
    AdditionalResponsibilities: [
      "First graduate scholarship In charge",
      "Newsletter In charge",
    ],

    AdditionalParticulars: [
      "Good knowledge in R software, SPSS and statistical analysis",
    ],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 205,
    image: Pirithiraj,
    fullName: "Dr.U.Pirithiraj",
    position: "Assistant Professor",
    department: "Department of Agricultural Entomology ",
    eMail: "u.pirithiraj@gmail.com",
    mobile: ["+91 9786919791"],
    deptType: "Crop Protection",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    educationalQualification: "Ph.D.(Entomology)",
    specialisation: "Insect Ecology and Host Plant Resistance",
    teachingExperience: "2 Years",
    researchExperience: "-",
    netEligibility: "ASRB/ICAR-NET",
    SeminarsPaperPresented: { national: "6", interNational: "4" },
    Trainingsattended: "5",
    Workshopsattended: "5",
    WorkshopsAttendeds: {
      Internationaljournal: "4",
      Nationaljournal: "5",
      Populararticles: "11",
      Bookschapters: "4",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "3",
    ListOutAward: ["Young Entomologist", "Young Scientist Award"],
    WebinarsAttended: "6",
    AdditionalResponsibilities: [
      "Exam Cell coordinator",
      "Beekeeping Unit In charge",
    ],

    AdditionalParticulars: [
      "Good knowledge in R software, SPSS and statistical analysis",
    ],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 206,
    image: Brindhadevi,
    fullName: "Dr.S.Brindhadevi",
    position: "Assistant Professor",
    department: "Plant Pathology ",
    eMail: "brindadevi555@gmail.com",
    mobile: ["+91 9786919791"],
    deptType: "Crop Protection",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    educationalQualification: "Ph.D.(Entomology)",
    specialisation: "Biological control",
    teachingExperience: "5 Years",
    researchExperience: "5 Years",
    netEligibility: "ASRB",
    SeminarsPaperPresented: { national: "4", interNational: "8" },
    Trainingsattended: "7",
    Workshopsattended: "7",
    WorkshopsAttendeds: {
      Internationaljournal: "12",
      Nationaljournal: "1",
      Populararticles: "25",
      Bookschapters: "12",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "3",
    ListOutAward: ["Best book contributor award", "Best article award"],
    WebinarsAttended: "6",
    AdditionalResponsibilities: [
      "Placement Cell Coordinator",
      "Plant Pathology Lab Incharge",
    ],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 207,
    image: JAYAPRAKASH,
    fullName: "Dr.K.Jayaprakash",
    position: "Assistant Professor",
    department: "Plant Pathology ",
    eMail: "jaypathology@gmail.com",
    mobile: ["+91 7550367198"],
    deptType: "Crop Protection",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    educationalQualification: "Ph.D",
    specialisation: "Plant Disease Management, Bio-Control ",
    teachingExperience: "3 Years",
    researchExperience: "-",
    netEligibility: "ASRB",
    SeminarsPaperPresented: { national: "1", interNational: "1" },
    Trainingsattended: "1",
    Workshopsattended: "1",
    WorkshopsAttendeds: {
      Internationaljournal: "2",
      Nationaljournal: "-",
      Populararticles: "-",
      Bookschapters: "-",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "3",
    ListOutAward: ["-"],
    WebinarsAttended: "-",
    AdditionalResponsibilities: ["Mushroom Production Unit in charge"],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 208,
    image: devanathan,
    fullName: "Mr.R.Devanathan",
    position: "Assistant Professor",
    department: "Horticulture",
    eMail: "devanathanramalingam@gmail.com",
    mobile: ["+91 9865265810"],
    deptType: "Horticulture",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    educationalQualification: "M.Sc.(Hort.)",
    specialisation: "Vegetable Science",
    teachingExperience: "9 Years",
    researchExperience: "5 Years",
    netEligibility: "-",
    SeminarsPaperPresented: { national: "6", interNational: "4" },
    Trainingsattended: "15",
    Workshopsattended: "4",
    WorkshopsAttendeds: {
      Internationaljournal: "4",
      Nationaljournal: "4",
      Populararticles: "3",
      Bookschapters: "3",
    },
    BookPublished: { WithISBN: "2", WithoutISBN: "" },
    AwardsReceived: "3",
    ListOutAward: ["-"],
    WebinarsAttended: "3",
    AdditionalResponsibilities: [
      "Horticulture Farm Manager",
      "Post-Harvest Lab incharge",
    ],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 209,
    image: AnbarasiD,
    fullName: "Dr.D.Anbarasi",
    position: "Assistant Professor",
    department: "Horticulture",
    eMail: "anbarasidevar@gmail.com",
    mobile: ["+91 9787579474"],
    deptType: "Horticulture",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    // educationalQualification: "M.Sc.(Hort.)",
    specialisation: "Vegetable Science",
    teachingExperience: "5 Years",
    researchExperience: "4 Years",
    netEligibility: "-",
    SeminarsPaperPresented: { national: "4", interNational: "3" },
    Trainingsattended: "2",
    Workshopsattended: "5",
    WorkshopsAttendeds: {
      Internationaljournal: "5",
      Nationaljournal: "3",
      Populararticles: "5",
      Bookschapters: "5",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "2" },
    AwardsReceived: "3",
    ListOutAward: ["-"],
    WebinarsAttended: "3",
    AdditionalResponsibilities: [
      "Horticulture Lab Incharge, ",
      "Vegetable production Inchage, ",
      "Botanical Garden Incharge, ",
      "Tamil Pudalvan  Incharge, ",
      "Pudhumaipen Scheme Incharge.",
    ],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 210,
    image: Praveena,
    fullName: "Mrs.P.Praveena",
    position: "Assistant Professor",
    department: "Horticulture",
    eMail: "ragavpraveena@gmail.com",
    mobile: ["+91 8523960523, +91 8655743908"],
    deptType: "Horticulture",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    // educationalQualification: "M.Sc.(Hort.)",
    specialisation: "Pomology (Fruit Science)",
    teachingExperience: "2 Years",
    researchExperience: "2 Years",
    netEligibility: "-",
    SeminarsPaperPresented: { national: "1", interNational: "1" },
    Trainingsattended: "6",
    Workshopsattended: "2",
    WorkshopsAttendeds: {
      Internationaljournal: "-",
      Nationaljournal: "-",
      Populararticles: "1",
      Bookschapters: "-",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "-",
    ListOutAward: ["-"],
    WebinarsAttended: "10",
    AdditionalResponsibilities: [
      "Year coordinator-2026 Batch-Horticulture, ",
      "Orchard Incharge, ",
      "Polyhouse Incharge. ",
    ],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 211,
    image: rashika,
    fullName: "Ms.R.Rashika",
    position: "Assistant Professor",
    department: "Horticulture",
    eMail: "rashikarhorti@gmail.com",
    mobile: ["+91 9442766764"],
    deptType: "Horticulture",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    // educationalQualification: "M.Sc.(Hort.)",
    specialisation: "Floriculture and Landscaping",
    netEligibility: "ASRB",
    teachingExperience: "1 Years",
    researchExperience: "5 Years",
    SeminarsPaperPresented: { national: "2", interNational: "2" },
    Trainingsattended: "5",
    Workshopsattended: "5",
    WorkshopsAttendeds: {
      Internationaljournal: "4",
      Nationaljournal: "1",
      Populararticles: "2",
      Bookschapters: "2",
    },
    BookPublished: { WithISBN: "1", WithoutISBN: "-" },
    AwardsReceived: "-",
    ListOutAward: ["-"],
    WebinarsAttended: "6",
    AdditionalResponsibilities: [
      "7.5 % quota Scholarship Coordinator,",
      "Exam Coordinator for B.Sc. (Hons) Horticulture, ",
      "Member in College admission committee,",
    ],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 212,
    image: abhinaya,
    fullName: "Ms.K.Abinaya",
    position: "Assistant Professor",
    department: "Food Science and Nutrition",
    eMail: "abinaya16012003@gmail.com",
    mobile: ["+91 9677875734"],
    deptType: "Horticulture",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    educationalQualification: "M.Sc.,",
    specialisation: "Food Science, Preservation, Nutritional Biochemistry",
    netEligibility: "UGC-NET",
    teachingExperience: "1 Years",
    researchExperience: "5 Years",
    SeminarsPaperPresented: { national: "2", interNational: "1" },
    Trainingsattended: "5",
    Workshopsattended: "2",
    WorkshopsAttendeds: {
      Internationaljournal: "-",
      Nationaljournal: "-",
      Populararticles: "-",
      Bookschapters: "-",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "-",
    ListOutAward: ["-"],
    WebinarsAttended: "5",
    AdditionalResponsibilities: [
      "Exam Coordinator,",
      "Women Hostel RT, ",
      "Anti-Ragging cell incharge.",
    ],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 214,
    image: Sundharavadivu,
    fullName: "Ms.S.Sundharavadivu",
    position: "Assistant Professor",
    department: "Agricultural Extension",
    eMail: "sundhatiasbhu@gmail.com",
    mobile: ["+91 7397611927"],
    deptType: "Social Sciences",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    // educationalQualification: "M.Sc.,",
    specialisation: "Agricultural Extension, Communication and Rural Sociology",
    netEligibility: "UGC, ASRB, ICAR",
    teachingExperience: "5 Years",
    researchExperience: "3 Years",
    SeminarsPaperPresented: { national: "5", interNational: "5" },
    Trainingsattended: "3",
    Workshopsattended: "6",
    WorkshopsAttendeds: {
      Internationaljournal: "2",
      Nationaljournal: "3",
      Populararticles: "1",
      Bookschapters: "2",
    },
    BookPublished: { WithISBN: "6", WithoutISBN: "1" },
    AwardsReceived: "1",
    ListOutAward: ["Best Faculty Award "],
    WebinarsAttended: "-",
    AdditionalResponsibilities: [
      "Best Faculty Award, ",
      "Social media update Incharge, ",
      "Editor, JSACAT Newsletter, ",
      "Exhibition Hall In charge, ",
      "RAWE Coordinator.",
    ],

    AdditionalParticulars: [
      "Life Member in International Society of Extension Education, Nagpur. ",
      "Life member in Journal of Global Communication, Australia",
    ],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },
  {
    id: 215,
    image: yogapriya,
    fullName: "Ms. R. Yoga Priya",
    position: "Assistant Professor",
    department: "Agricultural Extension",
    eMail: "yogapriyarengasamy286@gmail.com ",
    mobile: ["+91 8072260362"],
    deptType: "Social Sciences",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    // educationalQualification: "M.Sc.,",
    specialisation:
      "Agricultural Communication, Technology transfer and Participatory Extension Approaches",
    netEligibility: "-",
    teachingExperience: "1 Years",
    researchExperience: "2 Years",
    SeminarsPaperPresented: { national: "1", interNational: "-" },
    Trainingsattended: "1",
    Workshopsattended: "1",
    WorkshopsAttendeds: {
      Internationaljournal: "-",
      Nationaljournal: "-",
      Populararticles: "-",
      Bookschapters: "-",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "-",
    ListOutAward: ["-"],
    WebinarsAttended: "-",
    AdditionalResponsibilities: [
      "Academic Event Coordinator",
      "UPSC Coordinator,",
      "Education Loan Nodal Officer, ",
      "Girls Hostel Warden.",
    ],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 216,
    image: mKarthikeyan,
    fullName: "Mr. M. Karthikeyan",
    position: "Assistant Professor",
    department: "Social Sciences (Agricultural Economics)",
    eMail: "karthikknmurali@gmail.com ",
    mobile: ["+91 8667011176"],
    deptType: "Social Sciences",
    // dateOfBirth: "05.03.1998",
    // dateOfJoining: "25.02.2022",
    educationalQualification: "Ph.D.",
    specialisation: "Gender Studies",
    netEligibility: "-",
    teachingExperience: "2 Years",
    researchExperience: "-",
    SeminarsPaperPresented: { national: "2", interNational: "-" },
    Trainingsattended: "1",
    Workshopsattended: "2",
    WorkshopsAttendeds: {
      Internationaljournal: "-",
      Nationaljournal: "2",
      Populararticles: "-",
      Bookschapters: "-",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "-",
    ListOutAward: [
      "Dr. M S Swaminathan Research Excellence Award on the occasion of “National Conference and Award Ceremony on Innovations in Science, Agriculture and Adaptation to Climate Change",
    ],
    WebinarsAttended: "3",
    AdditionalResponsibilities: ["BC/MBC Scholarship incharge"],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },
  {
    id: 217,
    image: arun,
    fullName: "Mr. S. Arun",
    position: "Assistant Professor",
    department: "Agricultural Economics ",
    eMail: "arunsaravanan2282000@gmail.com ",
    mobile: ["+91 6379445011"],
    deptType: "Social Sciences",
    dateOfBirth: "22.08.2000",
    // dateOfJoining: "25.02.2022",
    educationalQualification: "M.Sc. (Agri.) Agricultural Economics",
    specialisation: "Agricultural Marketing and Production Economics",
    netEligibility: "Nil",
    teachingExperience: "Fresher",
    researchExperience: "2 years",
    SeminarsPaperPresented: { national: "1", interNational: "1" },
    Trainingsattended: "5",
    Workshopsattended: "4",
    WorkshopsAttendeds: {
      Internationaljournal: "-",
      Nationaljournal: "4",
      Populararticles: "1",
      Bookschapters: "1",
    },
    BookPublished: { WithISBN: "Nil", WithoutISBN: "Nil" },
    AwardsReceived: "Nil",
    ListOutAward: ["-"],
    WebinarsAttended: "-",
    AdditionalResponsibilities: [
      "Academic Event Coordinator",
      "Reappearance Exam Coordinator",
    ],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 218,
    image: senthil,
    fullName: "Mr. S. Senthil Murugan",
    position: "Assistant Professor",
    department: "COMPUTER SCIENCE ",
    eMail: "cssenthil452@gmail.com",
    mobile: ["+91 9751850010"],
    deptType: "Social Sciences",
    dateOfBirth: "22.08.2000",
    // dateOfJoining: "25.02.2022",
    educationalQualification: "MCA.,M.Ed.,M.Phil.,PG Dip (Yoga)",
    specialisation: "Computer science",
    netEligibility: "-",
    teachingExperience: "15 Years",
    researchExperience: "-",
    SeminarsPaperPresented: { national: "6", interNational: "4" },
    Trainingsattended: "2",
    Workshopsattended: "1",
    WorkshopsAttendeds: {
      Internationaljournal: "-",
      Nationaljournal: "-",
      Populararticles: "-",
      Bookschapters: "-",
    },
    BookPublished: { WithISBN: "1", WithoutISBN: "-" },
    AwardsReceived: "1",
    ListOutAward: ["-"],
    WebinarsAttended: "1",
    AdditionalResponsibilities: ["Computer Lab In charge,", "Principal PA"],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 219,
    image: JeevanathiyalR,
    fullName: "JeevanathiyalR",
    position: "Assistant Professor",
    department: "Mathematics",
    eMail: "jeevanathiyalravi@gmail.com",
    mobile: ["+91 7397118530"],
    deptType: "Social Sciences",
    // dateOfBirth: "22.08.2000",
    // dateOfJoining: "25.02.2022",
    educationalQualification: "M.Sc., (MAT)., M.Ed., M.Phil.,",
    specialisation: "Mathematics & Agriculture Statistics",
    netEligibility: "-",
    teachingExperience: "8 Years",
    researchExperience: "-",
    SeminarsPaperPresented: { national: "-", interNational: "1" },
    Trainingsattended: "2",
    Workshopsattended: "2",
    WorkshopsAttendeds: {
      Internationaljournal: "1",
      Nationaljournal: "1",
      Populararticles: "1",
      Bookschapters: "1",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "Best Teacher Award",
    ListOutAward: ["-"],
    WebinarsAttended: "1",
    AdditionalResponsibilities: [
      "NSS Programme Officer",
      "Alumni Cell Coordinator",
      "Sexual harassment Counseling Advisor",
      "Student Mentor",
    ],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 220,
    image: munnusamy,
    fullName: "Munusamy",
    position: "Physical Director",
    department: "Physical Education ",
    eMail: "munus301990@gmail.co",
    mobile: ["+91 9715793570"],
    deptType: "Social Sciences",
    // dateOfBirth: "22.08.2000",
    // dateOfJoining: "25.02.2022",
    // educationalQualification: "",
    specialisation: "-",
    netEligibility: "-",
    teachingExperience: "-",
    researchExperience: "-",
    SeminarsPaperPresented: { national: "-", interNational: "-" },
    Trainingsattended: "-",
    Workshopsattended: "-",
    WorkshopsAttendeds: {
      Internationaljournal: "-",
      Nationaljournal: "-",
      Populararticles: "-",
      Bookschapters: "-",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "-",
    ListOutAward: ["-"],
    WebinarsAttended: "-",
    AdditionalResponsibilities: ["-"],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },

  {
    id: 221,
    image: Sugadev,
    fullName: "Sugadev",
    position: "LIBRARIAN ",
    department: "Social Science",
    eMail: "Sugadev701@gmail.com",
    mobile: ["+91 8940340174"],
    deptType: "Social Sciences",
    // dateOfBirth: "22.08.2000",
    // dateOfJoining: "25.02.2022",
    // educationalQualification: "",
    specialisation: "Library Science",
    netEligibility: "-",
    teachingExperience: "-",
    researchExperience: "-",
    SeminarsPaperPresented: { national: "-", interNational: "-" },
    Trainingsattended: "-",
    Workshopsattended: "-",
    WorkshopsAttendeds: {
      Internationaljournal: "-",
      Nationaljournal: "-",
      Populararticles: "-",
      Bookschapters: "-",
    },
    BookPublished: { WithISBN: "-", WithoutISBN: "-" },
    AwardsReceived: "-",
    ListOutAward: ["-"],
    WebinarsAttended: "-",
    AdditionalResponsibilities: ["-"],

    AdditionalParticulars: ["-"],

    // googleScholar: "",
    // seminarsAttended: { national: "", interNational: "" },
    // conferenceAttended: { national: "", interNational: "" },
    WorkshopsAttended: { national: "6", interNational: "" },
    trainingsAttended: { national: "1", interNational: "" },
    facultyDevelopmentProgrammeAttended: { national: "", interNational: "" },
    // reviewPapersPresented: { national: "", interNational: "" },
    // researchPapersPresented: { national: "", interNational: "" },
    // reviewPapersPublished: { national: "", interNational: "" },
    researchPapersPublished: { national: "1", interNational: "" },
    // populararticlesPublished: { national: "", interNational: "" },
    // bookschaptersPublished: { national: "", interNational: "" },
    // booksPublished: { national: "", interNational: "" },
    // awards: {},
    // memberships: {},
  },
];